import api from './client';

// Sprint 2.8 T3-B — working-hours API client. Backend: /api/working-hours (T2).
// Mevcut api/*.js pattern'i (branches.js): (args) => api.method(path).then(r => r.data)

export const getWorkingHours = () => api.get('/working-hours').then(r => r.data);
export const updateWorkingHours = (updates) =>
  api.patch('/working-hours', { updates }).then(r => r.data);
